import { ActionItemDialog, ActionItemDialogReadonly } from "../../action-items/components/action-item.dialog";
import { CommunicationDialogReadonly } from "../../communications/components/communications-readonly.dialog";
import { CommunicationDialog } from "../../communications/components/communications.dialog";
import { CTMSSiteActionItemsSection } from "../../sites/scripts/site-action-items.section";
import { CTMSSiteCommunicationsSection } from "../../sites/scripts/site-communications.section";
import { DeliverableDialog } from "../../sites/scripts/site-deliverable.dialog";
import { CTMSSiteDeliverablesSection } from "../../sites/scripts/site-deliverables.section";
import { getData } from "../../sites/scripts/site.utilities";
import { CTMSHomeSitesSection } from "./home-sites.section";

export class CTMSHomePage {

    communicationsSection: CTMSSiteCommunicationsSection;
    actionItemsSection: CTMSSiteActionItemsSection;
    deliverablesSection: CTMSSiteDeliverablesSection;
    sitesSection: CTMSHomeSitesSection;

    actionItemDialog: ActionItemDialog | ActionItemDialogReadonly;
    // milestoneDialog: MilestoneDialog;
    deliverableDialog: DeliverableDialog;
    communicationDialog: CommunicationDialog | CommunicationDialogReadonly;

    isNonViewer: boolean;

    constructor(isNonViewer = true) {

        $(() => {
            this.isNonViewer = isNonViewer === true;

            this.communicationsSection = new CTMSSiteCommunicationsSection(`/secure/ctms/home/home?handler=Communications`, true);
            this.actionItemsSection = new CTMSSiteActionItemsSection(`/secure/ctms/home/home?handler=ActionItems`, true);
            this.deliverablesSection = new CTMSSiteDeliverablesSection(`/secure/ctms/home/home?handler=Deliverables`, true, false);
            this.sitesSection = new CTMSHomeSitesSection(`/secure/ctms/home/home?handler=Sites`);

            this.initTables();
            this.loadData();
            this.bindDialogs();

        });
    }

    initTables() {

    }

    async loadData() {

        this.communicationsSection.loadData();
        this.actionItemsSection.loadData();
        this.deliverablesSection.loadData();
        this.sitesSection.loadData();

        const dialogRefData = await getData('/secure/ctms/sites/site-details?handler=SharedReferenceData');

        if (this.isNonViewer) {
            this.communicationDialog = new CommunicationDialog(
                dialogRefData.allCommunicationsJson,
                dialogRefData.allCommunicationTypesJson,
                dialogRefData.allCommunicationTopicsJson,
                dialogRefData.allCommunicationStatusesJson,
                dialogRefData.allAttachmentTypesJson,
                dialogRefData.allSites,
                dialogRefData.allContactsJson,
                dialogRefData.allUsersJson
            );
            this.communicationDialog.successCallback = this.communicationDialogSuccess.bind(this);
        } else {
            this.communicationDialog = new CommunicationDialogReadonly(
                dialogRefData.allCommunicationsJson,
                dialogRefData.allCommunicationTypesJson,
                dialogRefData.allCommunicationTopicsJson,
                dialogRefData.allCommunicationStatusesJson,
                dialogRefData.allAttachmentTypesJson,
                dialogRefData.allSites,
                dialogRefData.allContactsJson,
                dialogRefData.allUsersJson
            );
        }

        if (this.isNonViewer) {
            this.actionItemDialog = new ActionItemDialog(
                dialogRefData.allActionItemsJson,
                dialogRefData.allActionItemTypesJson,
                dialogRefData.allActionItemStatusesJson,
                dialogRefData.allActionItemCriticalTypesJson,
                dialogRefData.allSites
            );
            this.actionItemDialog.successCallback = this.actionItemDialogSuccess.bind(this);
        } else {
            this.actionItemDialog = new ActionItemDialogReadonly(
                dialogRefData.allActionItemsJson,
                dialogRefData.allActionItemTypesJson,
                dialogRefData.allActionItemStatusesJson,
                dialogRefData.allActionItemCriticalTypesJson,
                dialogRefData.allSites
            );
        }

        this.deliverableDialog = new DeliverableDialog(dialogRefData.deliverableStatusList, !this.isNonViewer);
        this.deliverableDialog.successCallback = this.deliverableDialogSuccess.bind(this);



    }

    bindDialogs() {

        // Communications
        $(document).on('click', '#communicationsTable .ctms-icon-pencil', async (evt) => {
            const row = $(evt.target).closest('tr');
            const data = $('#communicationsTable').DataTable().row(row).data();
            if (!data || !data.Id) return;
            $('#newCommunicationEventDialogLabel').text('Edit Communication Event');
            const response = await getData(`/secure/ctms/communications/communications?handler=CommunicationEventDto&id=${data.Id}`);
            if (response && response.success && response.communicationEvent) {
                    if (this.communicationDialog) {
                        $('#newCommunicationEventDialog').modal('show');
                        this.communicationDialog.populateDialogFieldsFromDto(response.communicationEvent);
                        $('#communicationDialogTabSection').collapse('show');
                    }
                } else {
                    alert('Could not load communication event for editing.');
                }
        });

        $('#newCommunicationEventBtn').on('click', () => {
            $('#newCommunicationEventDialogLabel').text('New Communication Event');
            $('#communicationId').val(0);
            $('#communicationDialogTabSection').collapse('show');
        });

        // Action Items
        $(document).on('click', '#actionItemsTable .ctms-icon-pencil', async (evt) => {
            var row = $(evt.target).closest('tr');
            var data = $('#actionItemsTable').DataTable().row(row).data();
            if (!data || !data.Id) return;
            $('#newActionItemDialogLabel').text('Edit Action Item');
            const response = await getData(`/secure/ctms/action-items/action-items?handler=ActionItemDto&id=${data.Id}`);
            if (response && response.success && response.actionItem) {
                if (this.actionItemDialog) {
                    $('#newActionItemDialog').modal('show');
                    this.actionItemDialog.populateDialogFieldsFromDto(response.actionItem);
                }
            } else {
                alert('Could not load action item for editing.');
            }
        });

        $('#aiNewActionItemBtn').on('click', () => {
            $('#newActionItemDialogLabel').text('New Action Item');
            $('#actionItemId').val(0);
        });

        // Deliverables
        this.deliverablesSection.editCallback = (deliverable) => {
            this.deliverableDialog.resetDialog(deliverable);
            $('#editDeliverableDialog').modal('show');
        }
    }

    actionItemDialogSuccess(response) {
        this.actionItemsSection.loadData();
    }

    deliverableDialogSuccess(response) {
        this.deliverablesSection.loadData();
    }

    communicationDialogSuccess(response) {
        this.communicationsSection.loadData();
        this.actionItemsSection.loadData();
    }


}